import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  AdvancedSearchAdditionalFieldsComponent
} from '@app/pcs/shared/components/advanced-search/additional-fields/advanced-search-additional-fields.component';
import {
  AdvancedSearchInvolvedAgenciesLightsComponent
} from '@app/pcs/shared/components/advanced-search/additional-fields/agencies-lights/advanced-search-involved-agencies-lights.component';
import {
  AdvancedSearchInvolvedAgencyLightPairComponent
} from '@app/pcs/shared/components/advanced-search/additional-fields/agencies-lights/advanced-search-involved-agency-light-pair.component';
import {
  MyAgencyInvolvementComponent
} from '@app/pcs/shared/components/advanced-search/additional-fields/agency-involvement/my-agency-involvement.component';
import {
  MyAcceptanceIndicatorComponent
} from '@app/pcs/shared/components/advanced-search/additional-fields/my-acceptance-indicator/my-acceptance-indicator.component';
import { AdvancedSearchFormComponent } from '@app/pcs/shared/components/advanced-search/advanced-search-form.component';
import { PcsDirectivesModule } from '@app/pcs/shared/directives/pcs-directives.module';
import { SearchAdditionalFieldsModule } from '@app/pcs/shared/search/search-additional-fields.module';
import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    AdvancedSearchFormComponent,
    AdvancedSearchAdditionalFieldsComponent,
    AdvancedSearchInvolvedAgenciesLightsComponent,
    AdvancedSearchInvolvedAgencyLightPairComponent,
    MyAcceptanceIndicatorComponent,
    MyAgencyInvolvementComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    SharedModule,
    SearchAdditionalFieldsModule,
    PcsDirectivesModule
  ],
  providers: [],
  exports: [
    AdvancedSearchFormComponent
  ]
})
export class AdvancedSearchFormModule {
}
